export default __webpack_public_path__ + "static/media/10.06dc6613.png";